<template>
  <!-- 项目申报列表 -->
  <div class="projectApply">
    <div class="apply_image">
      <img class="apply_image" src="../../assets/projectApply.png" @click="goto">
    </div>
    <div class="apply">
      <div class="apply-box f-r j-b a-c">
        <div v-show="type == '0'" class="apply-title">项目列表</div>
        <div v-show="type == '1'" class="apply-title">项目详情</div>
        <div v-show="type == '2'" class="apply-title">我的申报记录</div>
        <div v-show="type == '0'" class="record-btn" @click="type = '2'">我的申报记录</div>
        <div v-show="type == '1' || type == '2'" class="record-btn" @click="backProjectList">返回项目列表</div>
      </div>
      <!-- 分割线 -->
      <div class="divider"></div>
      <!-- 查询条件 -->
      <el-form
        v-show="type == '0'"
        ref="form"
        :model="form"
        label-width="80px"
        inline
        class="f-r a-c"
      >
        <el-form-item label="申报状态">
          <el-select v-model="form.type" placeholder="请选择" clearable @change="queryProList">
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="—"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="reset" style="padding: 13px 20px;">重置</el-button>
        <el-input
          v-model="form.policyName"
          placeholder="请输入关键字"
          class="searchBtn"
          @keyup.native.enter="queryProList"
        >
          <i
            slot="suffix"
            style="cursor:pointer"
            class="el-input__icon el-icon-search"
            @click="queryProList"
          ></i>
        </el-input>
      </el-form>
      <!-- 表格信息 -->
      <div v-show="type == '0'" class="applyTable">
        <div v-show="programList.length == 0" class="empty">暂无数据</div>
        <div
          v-for="(item, index) in programList"
          :key="index"
          class="program f-r j-b a-c"
          @click="getProDetail(item.uuid)"
        >
          <div class="proItem-pic" :style="{ backgroundImage: `url(${item.pictureUrl})` }"></div>
          <div class="proItem-con f-c j-a">
            <div class="f-r j-b">
              <div class="proItem-title">{{ item.policyName }}</div>
              <div class="proItem-time">{{ item.createDate }}</div>
            </div>
            <div class="f-r">
              <div class="proItem-date">
                <span>开始时间：</span>
                {{ item.startDate }}
              </div>
              <div class="proItem-date">
                <span>截止时间：</span>
                {{ item.endDate }}
              </div>
              <div class="proItem-date">
                <span>专家评审：</span>
                {{ item.reviewDate }}
              </div>
            </div>
            <div @click.stop="getProDetail(item.uuid)" class="proItem-type">
              <span class="type" v-if="judgeDate(item.startDate, item.endDate) == 'reporting'">立即申请</span>
            </div>
            <img
              v-if="judgeDate(item.startDate, item.endDate) == 'complete'"
              class="typeImg"
              src="@/assets/publicService/program/complete.png"
              alt="已结束"
            />
            <img
              v-else-if="judgeDate(item.startDate, item.endDate) == 'not_starat'"
              class="typeImg"
              src="@/assets/publicService/program/not_starat.png"
              alt="未开始"
            />
            <img
              v-else
              src="@/assets/publicService/program/reporting.png"
              class="typeImg"
              alt="申报中"
            />
          </div>
        </div>
        <commonPag
          v-show="programList.length > 0"
          @currentChange="currentChange"
          :total="total"
          :currentPage="currentPage"
        ></commonPag>
      </div>
      <!-- 项目详情 -->
      <div v-show="type == '1'" class="pro-detail">
        <div class="info-title">{{ programInfo.policyName }}</div>
        <div class="info-time f-r j-a a-c" v-if="Object.keys(programInfo).length > 0">
          <div class="info-type">
            <img
              v-if="judgeDate(programInfo.startDate, programInfo.endDate) == 'complete'"
              class="infoImg"
              src="@/assets/publicService/program/complete.png"
              alt="已结束"
            />
            <img
              v-else-if="judgeDate(programInfo.startDate, programInfo.endDate) == 'not_starat'"
              class="infoImg"
              src="@/assets/publicService/program/not_starat.png"
              alt="未开始"
            />
            <img
              v-else
              src="@/assets/publicService/program/reporting.png"
              class="infoImg"
              alt="申报中"
            />
          </div>
          <div>开始时间：{{ programInfo.startDate }}</div>
          <div>截止时间：{{ programInfo.endDate }}</div>
          <div>专家评审：{{ programInfo.reviewDate }}</div>
        </div>
        <!-- 富文本 -->
        <div class="info-con" v-html="programInfo.policyContent">
          <div v-show="!programInfo.policyContent" class="empty">暂无数据</div>
        </div>
        <div v-if="judgeDate(programInfo.startDate, programInfo.endDate) == 'complete'" class="end-btn" @click="openDia">已结束</div>
        <div v-else class="info-btn" @click="openDia">立即申报</div>
        <el-dialog
          :visible.sync="dialogVisible"
          width="460px"
          top="40vh"
          :show-close="false"
          :modal="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <div class="dialog-title f-r j-c a-c">
            <i class="el-icon-question dialog-icon"></i>
            <span class="dialog-text">{{ tips }}</span>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false" plain>取 消</el-button>
            <el-button type="primary" @click="goZNZZ()" plain>智能制造</el-button>
            <el-button type="primary" @click="goLHRH()" plain>两化融合</el-button>
            <el-button type="primary" @click="apply()">继续申报</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 我的申报记录 -->
      <applyRecord v-show="type == '2'"></applyRecord>
    </div>
  </div>
</template>

<script>
import { queryProList, getProDetail, getRecord } from "../../utils/interface";
import moment from "moment";
import commonPag from "../../components/commonPag.vue";
import applyRecord from "./applyRecord";
export default {
  name: "",
  components: { commonPag, applyRecord },
  props: {},
  data() {
    return {
      nowDate: moment().format("YYYY-MM-DD"),
      headerBgUrl: require("../../assets/publicService/home/1.png"),
      form: {
        type: "", // 申报状态：0未开始，1进行中，2已结束
        startDate: "",
        endDate: "",
        policyName: "" //政策名称
      },
      date: "", // 起止时间
      type: "0", //'0'是项目列表页 '1'是详情页 '2'是申报记录页
      typeList: [
        { label: "全部", value: "" },
        { label: "未开始", value: "0" },
        { label: "申报中", value: "1" },
        { label: "已结束", value: "2" }
      ],
      programList: [
        // {
        //     pictureUrl: require('../../assets/publicService/home/22.png'),
        //     policyName: '自治区科技厅关于组织开展2024年度自治区级科技企业孵化器认定工作的通知',
        //     startDate: '2024-03-17',
        //     endDate: '2024-03-30',
        //     reviewDate: '2024-03-31',
        //     time: '2024-03-18',
        //     type: '立即申请',
        //     content: ''
        // }
      ],
      programInfo: {}, // 项目详情信息
      dialogVisible: false,
      tips:
        "请确认是否已完成智能制造和两化融合诊断评估，如未完成请先进行企业诊断。",
      total: 0,
      currentPage: 1
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == "projectReport") {
        // 如果从申报详情页返回，展示申报记录列表页
        // console.log("vm", vm);
        vm.type = "2";
      }
    });
  },
  watch: {
    date(val) {
      if (val) {
        // console.log(val)
        this.form.startDate = val[0];
        this.form.endDate = val[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.queryProList();
    }
  },
  computed: {},
  created() {},
  mounted() {
    // window.addEventListener("scroll", this.menu)
    this.queryProList();
    if (this.$route.query.uuid) {
      this.getProDetail(this.$route.query.uuid);
    }
  },
  methods: {
    menu() {
      let scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      let footer = document.querySelector(".newFooter").offsetTop;
      // console.log('scroll  ' + scroll)
      if (scroll > footer) {
        console.log("111");
      }
    },
    /* 返回项目列表 */
    backProjectList() {
      this.type = "0";
      document.title = "项目列表";
    },
    /* 查询项目列表 */
    queryProList() {
      queryProList({
        state: "1",
        rec: "1",
        current: this.currentPage,
        pageSize: 5,
        ...this.form
      }).then(res => {
        if (Object.keys(res).length > 0 && res.list.length > 0) {
          this.programList = res.list;
          this.total = res.total;
        } else {
          this.programList = [];
          this.total = 0;
        }
      });
    },
    /* 详情 */
    getProDetail(uuid) {
      this.type = "1";
      document.title = "项目详情";
      getProDetail(uuid).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.programInfo = res.data;
        } else {
          this.programInfo = {};
        }
      });
    },
    /* 查询项目申报记录 */
    getRecord() {
      return new Promise(resolve => {
        getRecord({
          policyUuid: this.programInfo.uuid,
          userUuid: this.$store.state.isUsermessage.uuid
        }).then(res => {
          if (res.list.length >= 2) {
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    },
    /* 立即申报 */
    openDia() {
      let now = new Date(this.nowDate);
      let start = new Date(this.programInfo.startDate);
      let end = new Date(this.programInfo.endDate);
      if (now < start) {
        // 未开始
        this.$message({
          showClose: true,
          message: "还未到申报时间",
          type: "warning"
        });
      } else if (now >= start && now <= end) {
        let newToken = this.$cookies.get("api_token_new");
        // console.log('token:', newToken, this.$store.state.isUsermessage)
        if (!newToken) {
          // 未登录的话先登录
          this.$router.push("/login");
        } else if (
          this.$store.state.isUsermessage.identity === "PERSONAL" ||
          this.$store.state.isUsermessage.identity === "ANONYMOUS"
        ) {
          // 没有经过企业认证的话去认证
          this.$confirm("请先进行企业资质认证!", "提示", {
            confirmButtonText: "去认证",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            window.sessionStorage.setItem("userServeId", "11");
            let routeData = this.$router.resolve({
              name: "userCenter",
              params: {
                userServeId: "11"
              }
            });
            window.open(routeData.href, "_target");
          });
          return false;
        }
        // 申报中
        let flag = this.getRecord();
        flag.then(val => {
          if (val) {
            this.dialogVisible = true;
          } else {
            this.$message({
              showClose: true,
              message: "一个项目政策最多申报两次，请勿重复申报",
              type: "warning"
            });
          }
        });
      } else if (now > end) {
        // 已结束
        this.$message({
          showClose: true,
          message: "已过申报截至时间",
          type: "warning"
        });
      }
    },
    /* 智能制造 */
    goZNZZ() {
      window.open("https://www.c3mep.cn/login", "_blank");
      this.dialogVisible = false;
    },
    /* 两化融合 */
    goLHRH() {
      window.open("https://nxpg.cspiii.com/userLogin", "_blank");
      this.dialogVisible = false;
    },
    /* 去申报 */
    apply() {
      this.dialogVisible = false;
      let router = this.$router.resolve({
        path: "./projectReport",
        query: {
          policyUuid: this.programInfo.uuid
        }
      });
      window.open(router.href, "_blank");
    },
    judgeDate(startDate, endDate) {
      let now = new Date(this.nowDate);
      let start = new Date(startDate);
      let end = new Date(endDate);
      if (now < start) {
        // 未开始
        return "not_starat";
      } else if (now > start && now < end) {
        // 申报中
        return "reporting";
      } else if (now > end) {
        // 已结束
        return "complete";
      }
    },
    currentChange(Page) {
      // console.log('currentPage:', currentPage)
      this.currentPage = Page.currentPage;
      this.queryProList();
    },
    reset() {
      this.form = {
        type: "", // 申报状态：0未开始，1进行中，2已结束
        startDate: "",
        endDate: "",
        policyName: "" //政策名称
      };
    },
    goto(){
      window.location.href='https://jsq.nxinfo.org.cn/'
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@basic-colors: #2d50a1;

.projectApply {
  position: relative;
  padding: 0px 0;
  background-color: #f5f5f5;

  .apply_image{
    width: 1300px;
    height: 200px;
    margin: 0 auto;
    position: relative;
    cursor:pointer;
  }

  .apply {
    width: 1300px;
    min-height: 400px;
    background-color: #fff;
    margin: 0 auto;
    border: 1px solid #efefef;
    //border-radius:0px 0px 12px 12px;
    position: relative;
    box-sizing: border-box;
    padding: 20px 20px 0;

    .divider {
      height: 2px;
      background-color: #efefef;
      padding: 0 20px;
      margin: 25px 0;
    }

    .apply-box {
      .apply-title {
        font-size: 24px;
        font-weight: 600;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 2px;
          background-color: @basic-colors;
          bottom: 0;
          left: 0;
          top: 58px;
        }
      }

      .record-btn {
        height: 38px;
        padding: 0 8px;
        color: #fff;
        cursor: pointer;
        .bc(100%);
        .lh(38px);
        .bs();
        .br(4px);
      }
    }

    .searchBtn {
      position: absolute;
      width: 200px;
      right: 40px;
    }

    .applyTable {
      margin: 0 20px 0 12px;
      min-height: 200px;
      overflow: hidden;
      position: relative;

      .program {
        width: 100%;
        height: 135px;
        padding: 18px 0;
        border-bottom: 1px solid #efefef;
        .bs();
        .proItem-pic {
          width: 180px;
          height: 102px;
          .bg();
        }

        .proItem-con {
          flex: 1;
          align-self: stretch;
          margin-left: 35px;
          position: relative;

          .proItem-title {
            font-size: 18px;
            font-weight: bold;
            &:hover {
              cursor: pointer;
            }
          }

          .proItem-date {
            font-size: 14px;
            margin-right: 20px;

            span {
              color: #9c9eab;
            }
          }

          .typeImg {
            position: absolute;
            left: 0;
            bottom: 4px;
            width: 80px;
            height: 27px;
          }

          .proItem-type {
            height: 25px;
            box-sizing: border-box;
            text-align: right;

            .type {
              width: 80px;
              height: 25px;
              display: inline-block;
              text-align: center;
              padding: 1px 0;
              color: @basic-colors;
              border: 1px solid @basic-colors;
              border-radius: 4px;
              cursor: pointer;
              align-self: end;
              .bc(14%);
              .bs();
            }
          }
        }
      }
    }

    .pro-detail {
      .info-title {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
      }

      .info-time {
        width: 100%;
        height: 90px;
        border: 1px solid #efefef;
        margin: 20px 0;
        position: relative;
        .br();

        .info-type {
          position: absolute;
          left: 0;
          top: 0px;
          width: 80px;
          height: 27px;
          border-top-left-radius: 12px;

          .infoImg {
            width: 80px;
            height: 27px;
          }
        }
      }

      .info-con {
        padding: 20px 40px;
        min-height: 300px;
        position: relative;
      }

      .info-btn {
        position: sticky;
        bottom: 20px;
        width: 160px;
        height: 40px;
        .lh(40px);
        text-align: center;
        border-radius: 20px;
        color: #fff;
        font-size: 18px;
        margin: 20px auto;
        cursor: pointer;
        .bc();
      }

      .end-btn {
        position: sticky;
        bottom: 20px;
        width: 160px;
        height: 40px;
        .lh(40px);
        background-color: #9C9C9C !important;
        text-align: center;
        border-radius: 20px;
        color: #fff;
        font-size: 18px;
        margin: 20px auto;
        cursor: pointer;
      }

      .dialog-icon {
        font-size: 30px;
        color: #cf9236;
        margin-right: 10px;
      }

      .dialog-text {
        color: #535353;
      }
    }
  }

  /deep/ .el-input__icon {
    font-size: 18px;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  /deep/ .el-dialog__header {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/projectApply/index.vue